<style lang="less">
    .vertical-center-modal{
        display: flex;
        align-items: center;
        justify-content: center;

        .ivu-modal{
            top: 0;
        }
    }
    .demo-spin-icon-load{
        animation: ani-demo-spin 1s linear infinite;
    }
    @keyframes ani-demo-spin {
        from { transform: rotate(0deg);}
        50%  { transform: rotate(180deg);}
        to   { transform: rotate(360deg);}
    }
    .demo-spin-col{
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        border: 1px solid #eee;
    }
</style>
<template>
  <div >
    <template v-if="modeltype==='upload'">
    <Modal  title="上传文件" v-model="showUpload" class-name="vertical-center-modal" :footer-hide="true">
        <div class="demo-spin-col">
        <Row v-if="showType" type="flex" justify="center"   align="middle"  :gutter="4" style="margin-bottom: 20px">
            <Col>
                <RadioGroup v-model="type" @on-change="typeChange">
                    <Radio v-for="(item,index) in myConfig.typeData" :label="item.code" class="efuture-radiogroupbox-radio">
                        <span>{{item.name}}</span>
                    </Radio>
                </RadioGroup>
            </Col>
        </Row>
        <Row type="flex" justify="center" align="middle"  :gutter="4">
            <Col v-if="hackReset">
                 <Upload ref="upload"
                    :before-upload="handleUpload"
                    accept=".xlsx,.xls" 
                    :format="myConfig.fileType"
                    :on-format-error="handleFormatError"
                    :on-success="handleSuccess"
                    :show-upload-list="false"
                    :action="resultUrl">
                        <Button>浏览</Button>
                        </Upload>
            </Col>
            <Col>
                <Poptip trigger="focus">
                 <Input v-model="name" style="width:300px"clearable readonly/>
                    <div slot="content">{{filename}}</div>
                </Poptip>   
            </Col>
            <Col>
                <Button @click="upload">上传</Button>
            </Col>
            
        </Row>
         <Spin v-show="loading" fix>
                <CommonIcon type="ios-loading" size="18" class="demo-spin-icon-load"></CommonIcon>
                <div>导入中</div>
        </Spin>
        </div>
    </Modal>
    <Modal :styles="{width:'60%'}"  class-name="vertical-center-modal"  v-model="importlog"  :footer-hide="true">
        <ImportLog v-if="importlogHackReset" ref="grid" :config="gridConfig"/>
    </Modal>
    </template>
  </div>
</template>
<script>
    import ImportLog from './importlog.vue';
    export default {
        name:'billexcelimport',
        components: {ImportLog},
        data () {
            return {
                myConfig:{
                    typeData:[],
                    fileType:['xlsx','xls']
                },
                file: null,
                modeltype:'upload',
                name:'',
                type:'',
                showType:false,
                showUpload:false,
                url:'',
                resultUrl:'',
                param:{},
                headers:{},
                loading:false,
                hackReset:true,
                importlogHackReset:true,
                importlog:false,
                gridConfig:{
                    hide:false,
                    bordered:false,
                    disHover:true,
                    titleType:2
                }
            };
        },
        props:{
            config: {
                type:Object,
                default () {
                    return {};
                }
            }
        } ,
        computed:{
            filename(){
                if (this.name) {
                    return this.name;
                } else {
                    return '请选择Excel文件';
                }
            }
        },
        created () {
            this.init();
        },
        methods: {
            typeChange (e) {
                this.headers = {};
                this.param.eid = e.value;
                this.resultUrl = this.url + '&param='+ encodeURI(JSON.stringify(this.param));
                this.hackReset = false;
                this.$nextTick(() =>{
                    this.hackReset = true;
                });
            },
            init () {
                if (this.config) {
                    let config = this.$Method.copy(this.config);
                    for (let temp2 in this.myConfig) {
                        if (config[temp2] !== undefined) {
                            this.myConfig[temp2] = config[temp2];
                        }
                    }
                    if (this.myConfig.typeData && this.myConfig.typeData.length > 0) {
                        this.showType = true;
                        this.type = this.myConfig.typeData[0].code;
                    }
                }
            },
            setModeltype(value) {
                this.modeltype = value;
            },
            setShowUpload(flag) {
                this.showUpload = flag;
            },
            setUrl(url,srvname,param) {
                if (url) {
                    this.gridConfig.resources = url;
                    this.importlogHackReset = false;
                    this.$nextTick(() => {
                        this.importlogHackReset = true;
                    });
                    url = url.replace('rest', 'importExcel');
                }
                let self = this;
                this.url = this.getResturl(url,null,{},self);
                if (this.myConfig.typeData.length > 1) {
                    this.type = this.myConfig.typeData[0].code;
                    param.eid = this.type;
                }
                Object.assign(this.param, param);
                this.url = this.url +'&srvname=' + srvname;
                this.resultUrl = this.url + '&param='+ encodeURI(JSON.stringify(this.param));
            },
            setDownUrl(url,param) {
                if (url) {
                    url = url.replace('rest', 'exportExcelTemplate');
                }
                let self = this;
                url = this.getResturl(url, null, {}, self);
                let temp  = url +'&param=' +encodeURI(JSON.stringify(param));
                window.open(temp,'_self');
            },
            handleUpload (file) {
                if (!this.checkFormat(file)) {
                    this.handleFormatError(file);
                    this.file = null;
                    this.name = '';
                    return false;
                } else {
                    this.file = file;
                    this.name = file.name;
                }
                return false;
            },
            checkFormat(file) {
                const _file_format = file.name.split('.').pop().toLocaleLowerCase();
                const checked = this.myConfig.fileType.some(item => item.toLocaleLowerCase() === _file_format);
                return checked;
            },
            upload () {
                if (!this.name) {
                    this.file = null;
                }
                if (this.file !== null) {
                    this.loading = true;
                    this.$refs.upload.post(this.file);
                }
            },
            handleFormatError (file) {
                let type = this.myConfig.fileType.join(',');
                this.alert('文件[' + file.name + ']的格式不正确，请上传格式为(' + type + ')的文件');
            },
            handleSuccess(res) {
                if (res && res.returncode !== '0') {
                    this.alert(res.data);
                    this.importSuccess(res);
                } else {
                    if (res.data) {
                        if (res.data.seqno) {
                            let self = this;
                            self.importSuccess(res);
                            self.$nextTick(() => {
                                self.$Modal.confirm({
                                    title:'确认',
                                    content:'导入存在错误信息，是否查看详情？',
                                    onOk:() => {
                                        self.importlog = true;
                                        self.$nextTick(() => {
                                            self.$refs.grid.refurbish(res.data.seqno);
                                        });
                                    },
                                    onCancel:() => {
                                        self.importSuccess(res);
                                    }
                                });
                            });  
                            
                        } else {
                            if (res.data.errmsg) {
                                this.alert(res.data.errmsg, res.data.msg);
                            } else {
                                this.alert(res.data.msg,null);
                            }
                            this.importSuccess(res);
                        }
                    } else {
                        this.importSuccess(res);
                    }
                }
               
            },
            importSuccess (res) {
                this.showUpload = false;
                this.file = null;
                this.name = '';
                this.loading = false;
                this.$nextTick(() => {
                    if (this.$parent.importSuccess) {
                        this.$parent.importSuccess(res);
                    }
                });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/layouttemplate/billimport.vue